import { provideZoneChangeDetection } from "@angular/core";
import { provideRouter, RouteReuseStrategy, withRouterConfig } from "@angular/router";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";

import { provideHighcharts } from "highcharts-angular";

import { AppComponent } from "./app/app.component";
import { appRoutes, routingConfig } from "./app/app.routing";
import { ApiService } from "./app/api.service";
import { AuthGuardGlobalAdminService, AuthGuardMasterService, AuthGuardOrgAdminService, AuthGuardService, AuthGuardSupportService } from "./app/auth-guard.service";
import { ChartingService } from "./app/charting.service";
import { FleetTrackerService } from "./app/fleet-tracker.service";
import { GitVersionService } from "./app/gitversion.service";
import { NoReuseStrategy } from "./app/no-reuse.strategy";

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),
		provideRouter(appRoutes, withRouterConfig(routingConfig)),
		provideHttpClient(withXhr(), withInterceptorsFromDi()),
		provideHighcharts({
			instance: () => import("highcharts/esm/highcharts").then(m => m.default),
			modules: () => [
				import("highcharts/esm/highcharts-more"),
				import("highcharts/esm/modules/boost"),
			],
		}),
		ApiService,
		AuthGuardService,
		AuthGuardOrgAdminService,
		AuthGuardGlobalAdminService,
		AuthGuardMasterService,
		AuthGuardSupportService,
		ChartingService,
		FleetTrackerService,
		GitVersionService,
		{ provide: RouteReuseStrategy, useClass: NoReuseStrategy },
	]
}
);
